import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { RepositoryUpload } from './RepositoryUpload';
import { RepositoryDocumentList } from './RepositoryDocumentList';

export function RepositoryView() {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleUploadComplete = () => {
    // Trigger refresh of document list
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="container mx-auto py-8 space-y-8">
      <div>
        <h1 className="text-3xl font-bold">Document Repository</h1>
        <p className="text-gray-600 mt-2">
          Upload reference documents once and reuse them across all projects
        </p>
      </div>

      <Tabs defaultValue="documents" className="w-full">
        <TabsList className="grid w-full max-w-md grid-cols-2">
          <TabsTrigger value="documents">My Documents</TabsTrigger>
          <TabsTrigger value="upload">Upload</TabsTrigger>
        </TabsList>

        <TabsContent value="documents" className="mt-6">
          <RepositoryDocumentList refreshTrigger={refreshTrigger} />
        </TabsContent>

        <TabsContent value="upload" className="mt-6">
          <RepositoryUpload onUploadComplete={handleUploadComplete} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
